import React, { useEffect, useState } from 'react'
import './Domu.scss'

const Domu = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [currentWord, setCurrentWord] = useState(0)
  
  const words = ['rychle', 'bezpečně', 'profesionálně']

  useEffect(() => {
    setIsVisible(true)
    
    // Animace střídání slov
    const interval = setInterval(() => {
      setCurrentWord(prev => (prev + 1) % words.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [])

  const handleCTAClick = (action) => {
    let targetId = ''
    
    if (action === 'register') {
      targetId = 'kontakt'
    } else if (action === 'price') {
      targetId = 'cenik'
    }
    
    if (targetId) {
      const element = document.getElementById(targetId)
      if (element) {
        const headerHeight = window.innerWidth < 768 ? 80 : 100
        const elementPosition = element.offsetTop
        const offsetPosition = elementPosition - headerHeight

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  return (
    <div className="home-section">
      {/* Floating shapes for background */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="section-content">
        <div className="hero-content">
          <div className={`hero-text ${isVisible ? 'animate-in' : ''}`}>
            <h1>
              Autoškola Příkaský
              <span className="gradient-text">Vaše cesta k řidičskému průkazu</span>
            </h1>
            
            <div className="subtitle">
              <span>Kyjov | </span>
              <span className="rotating-words">
                {words.map((word, index) => (
                  <span 
                    key={word}
                    className={`word ${index === currentWord ? 'active' : ''}`}
                  >
                    {word}
                  </span>
                ))}
              </span>
            </div>

            <p className="hero-description">
              Získejte řidičský průkaz s námi! Moderní vozový park, zkušený instruktor 
              a individuální přístup zaručují úspěch už od první jízdy.
            </p>

            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">10+</span>
                <span className="stat-label">let zkušeností</span>
              </div>
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">úspěšných absolventů</span>
              </div>
              <div className="stat">
                <span className="stat-number">Vysoká</span>
                <span className="stat-label">úspěšnost u zkoušek</span>
              </div>
            </div>

            <div className="hero-cta">
              <button 
                className="btn btn-primary"
                onClick={() => handleCTAClick('register')}
              >
                <span>Přihlásit se na kurz</span>
                <div className="btn-shine"></div>
              </button>
              
              <button 
                className="btn btn-secondary"
                onClick={() => handleCTAClick('price')}
              >
                <span>Zjistit cenu</span>
              </button>
            </div>
          </div>

          <div className={`hero-visual ${isVisible ? 'animate-in' : ''}`}>
            <div className="car-illustration">
              <div className="car-body">
                <div className="car-window"></div>
                <div className="car-door"></div>
                <div className="car-wheel wheel-front"></div>
                <div className="car-wheel wheel-back"></div>
              </div>
              <div className="road"></div>
            </div>
            
            <div className="floating-elements">
              <div className="element element-1">🚗</div>
              <div className="element element-2">🚙</div>
              <div className="element element-3">🛵</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Domu